package com.ustadmobile.core.domain.clazzenrolment.pendingenrolment

class AlreadyEnroledInClassException : Exception()
